import React, { useRef, useEffect } from 'react';

const FamilyInput = ({ customFamily, setCustomFamily, handleCustomFamilySubmit, loading }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  });

  return (
    <div className="flex items-center gap-2">
      <input
        ref={inputRef}
        type="text"
        placeholder="Ex: 40, 22, 15, 8"
        value={customFamily}
        onChange={(e) => setCustomFamily(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleCustomFamilySubmit();
          }
        }}
        className="px-3 py-2 border border-gray-300 rounded-md w-48"
      />
      <button
        onClick={handleCustomFamilySubmit}
        disabled={loading}
        className={`px-4 py-2 rounded-md font-medium transition-colors flex items-center justify-center bg-gray-600 text-white hover:bg-gray-700 disabled:bg-gray-400`}
      >
        {loading ? 'Chargement...' : 'Générer Famille Custom'}
      </button>
    </div>
  );
};

export default FamilyInput;
